import React, { ReactNode } from "react";
import cn from "classnames";
import s from "../ComparisonTable.module.scss";

type NavigationProps = {
  children: ReactNode;
  showPrev?: boolean;
  showNext?: boolean;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const Navigation: React.FC<NavigationProps> = ({
  children,
  showPrev = false,
  showNext = false,
  className,
  ...props
}) => {
  const shouldShow = showPrev || showNext;

  return (
    <div
      className={cn(s.navigation, {
        [s.visible]: shouldShow
      }, className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default Navigation;